const additionalInfoSaveKeys = [
  'gap_id',
  'gap_src_ref',
  'gap_pri_ref',
  'gap_owner_ref',
  'gap_due_date'
];

export default additionalInfoSaveKeys;
